import React from 'react'
import { TimeUnit } from './timeUnit'

interface ArrowProps {
  direction: 'up' | 'down'
  unit: TimeUnit
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
}

export default function Arrow({ direction, unit, onClick }: ArrowProps) {
  const label = `${direction === 'up' ? 'increment' : 'decrement'}-${
    unit === TimeUnit.MINUTE ? 'minute' : 'hour'
  }`

  return (
    <button
      aria-label={label}
      className={`arrow ${direction}`}
      onClick={onClick}
    >
      <i className={`fa fa-chevron-${direction}`} />
    </button>
  )
}
